// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import ActivateUserModal from 'Containers/ActivateUser/ActivateUserModal';

const StyledActivateUserPage = styled.div`
  width: 100vw;
  height: 100vh;
`;

const ActivateUserPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let activateUserPageClassName = bodyAttributes?.class || '';
  if (!activateUserPageClassName.includes('ActivateUserPage')) {
    activateUserPageClassName += 'ActivateUserPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.activateAccount') }</title>
        <body className={ activateUserPageClassName } />
      </Helmet>
      <StyledActivateUserPage theme={ theme } className="grid-container">
        <ActivateUserModal />
      </StyledActivateUserPage>
    </>
  );
});
ActivateUserPage.displayName = 'ActivateUserPage';

export default ActivateUserPage;
